export default __webpack_public_path__ + "static/media/maintenance_flag.977f358e.svg";